export default __webpack_public_path__ + "static/underline-19-1ab1e694ec5cb3a563e33ba6af5e3454.svg";